import groq from 'groq'

export const muxVideoFragment = groq`
  muxVideo {
    asset->,
  },
`

export const videoSettingsFragment = groq`
  settings {
    controls,
    customControls,
    autoplay,
    loop,
    muted,
  },
`

export const videoAspectRatioFragment = groq`
  aspectRatio {
    custom,
    mobile,
    desktop,
  },
`

export const videoFragment = groq`
  type,
  ${muxVideoFragment}
  ${videoSettingsFragment}
  ${videoAspectRatioFragment}
`
